import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  background: white;
  font-size: 14px;
  line-height: 1.5;
  padding: ${theme.unit * 1.5}px;
  text-align: left;

  ${({ square }) => !square && `
    border-radius: ${theme.unit}px;
  `};

  ${({ error }) => error && `
    background: ${theme.colors.destructiveColor.lighten(0.95)};
    box-shadow: inset 0 0 0 1px ${theme.colors.destructiveColor.darken(0.1)};
  `}

  ${({ warning }) => warning && `
    background: #f6f6ee;
  `}

  ${({ success }) => success && `
    background: #d4ece6;
  `}
`);



// WEBPACK FOOTER //
// ./src/components/text/Message.js